const API_URL = "https://www.dupaws.com/services/";

import auth from "../auth";
import store from "../data/store";

export default {
  updateCountry(countryId) {
    var self = this;
    return $.ajax({
      type: "GET",
      url:
        "https://www.dupaws.com/services/api/account/updateCountry/" +
        countryId,
      contentType: "application/json; charset=utf-8",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      success: function (data) {},
      error: function () {
        try {
          self.error = "Updating user failed, try again..";
        } catch (e) {
          self.error =
            "Oops we are having problem logging to the server, please try again in a moment..";
        }
      },
    });
  },
  initCountry() {
    var self = this;
    var countryId = 0;
    if (localStorage.getItem("CountryId") != null)
      countryId = localStorage.getItem("CountryId");
    return $.ajax({
      type: "GET",
      url: API_URL + "public/initCountry/" + countryId,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        if (data.IsSupportedCountry == true) {
          store.dispatch("CountryData", data);
          self.getCitiesList(data.CountryId, 0);
          store.dispatch("SelectCountry", false);
          localStorage.setItem("CountryId", data.CountryId);
        } else {
          store.dispatch("SelectCountry", true);
        }
      },
      error: function (data, status, error) {
        console.log("Unable to get Country Data" + data.responseText);
      },
    });
  },
  initUserSubscription() {
    var self = this;
    return $.ajax({
      type: "GET",
      url: "https://www.dupaws.com/services/api/initUserSubscriptionStatus/",
      contentType: "application/json; charset=utf-8",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      success: function (data) {
        store.dispatch("SubscriptionStatus", data);
      },
      error: function () {
        try {
          self.error = "Init user subscription failed..";
        } catch (e) {
          self.error =
            "Oops we are having problem logging to the server, please try again in a moment..";
        }
      },
    });
  },
  initStaycationData() {
    var self = this;
    return $.ajax({
      type: "GET",
      url: API_URL + "public/initStaycationData/",
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("StaycationData", data);
        if (data.Manifest != null) {
          if (
            localStorage.getItem("manifest") != null &&
            localStorage.getItem("manifest") == data.Manifest
          ) {
            //do nothing as manifest in sync
          } else if (localStorage.getItem("manifest") == null) {
            localStorage.setItem("manifest", data.Manifest);
          } else if (localStorage.getItem("manifest") != data.Manifest) {
            localStorage.setItem("manifest", data.Manifest); //updating manifest with new version.
            location.reload();
          } else {
            console.log("unknown error with manifest");
          }
        } else {
          console.log("manifest was null");
        }
      },
      error: function (data, status, error) {
        console.log("Unable to get Staycation Data" + data.responseText);
      },
    });
  },
  getCitiesList(countryId, regionId) {
    return $.ajax({
      type: "GET",
      url: API_URL + "api/cities/" + countryId + "/" + regionId,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("CitiesList", data);
      },
      error: function (data, status, error) {
        console.log("Unable to get Cities" + data.responseText);
      },
    });
  },

  getAreasList(cityId) {
    return $.ajax({
      type: "GET",
      url: API_URL + "api/areas/" + cityId,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("AreasList", data);
      },
      error: function (data, status, error) {
        console.log("Unable to get Areas" + data.responseText);
      },
    });
  },

  getFilteredAreasList(queryData) {
    return $.ajax({
      type: "POST",
      url: API_URL + "api/filteredAreas/",
      dataType: "json",
      data: JSON.stringify(queryData),
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("FilteredAreasList", data);
      },
      error: function (data, status, error) {
        console.log("Unable to get Filtered Areas" + data.responseText);
      },
    });
  },
  getNotifications(userRole) {
    return $.ajax({
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      url: API_URL + "api/getNotifications/" + userRole,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        if (data != null)
          if (data.length > 0) store.dispatch("Notifications", data);
      },
      error: function (data, status, error) {
        console.log("failed to get Notifications");
      },
    });
  },
  getSittersList(queryData) {
    return $.ajax({
      type: "POST",
      url: API_URL + "/public/sittersList/" + localStorage.getItem("CountryId"),
      dataType: "json",
      data: JSON.stringify(queryData),
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("SittersList", data);
        if (store.getters.QueryData.cityId != null && data.Areas != null)
          store.dispatch("FilteredAreasList", data.Areas);
      },
      error: function (data, status, error) {
        console.log(
          "failed to get Sitter getSittersList()" + data.responseText
        );
      },
    });
  },
  getSitterPublicDetails(sitterId) {
    return $.ajax({
      type: "GET",
      url: API_URL + "public/getSitterPublicDetails/" + sitterId,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("SitterPublicDetails", data);
      },
      error: function (data, status, error) {
        console.log(
          "failed to get Sitter getPublicSitterDetails()" + data.responseText
        );
      },
    });
  },
  initQuery() {
    return $.ajax({
      type: "GET",
      url: API_URL + "public/getQueryData/",
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        store.dispatch("QueryData", data);
      },
      error: function (data, status, error) {},
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/commonApi.js